import type { UseMediaQueryOptions } from '#src/styling/use_media_query.ts';
import { useMediaQuery } from '#src/styling/use_media_query.ts';

const DESKTOP_MEDIA_QUERY = '(min-width: 640px)';
const DEFAULT_MEDIA_QUERY_OPTIONS: UseMediaQueryOptions = {
  getInitialValueInEffect: false,
};

export function useShouldAdaptToDrawer(options = DEFAULT_MEDIA_QUERY_OPTIONS) {
  const isDesktop = useMediaQuery(DESKTOP_MEDIA_QUERY, true, options);
  return !isDesktop;
}
